import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 5: Kings and Queens: the Royalty of Korea</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 5: 조선 황실</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">
<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-5-Kings-and-Queens--the-Royalty-of-Korea-e15ao6r">here</a>!</span> <br></br>
<br></br>

{/*INTRO*/} 
고려 (goryeo) — kingdom that ruled in the Korean peninsula from year 936 to 1388 (pictured below)<br></br>
<img className="epPic" src="https://newsroom.korea.net/upload/content/editImage/20201229150655854_AAF7XRHO.png"></img><br></br>
<br></br>
<br></br> Pictured below: the flag of 고려 (goryeo)<br></br>
<img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Royal_flag_of_Goryeo_%28Bong-gi%29.svg/1200px-Royal_flag_of_Goryeo_%28Bong-gi%29.svg.png"></img><br></br>
<br></br>
한반도 (han ban do) — Korean peninsula <br></br>
지배하다 (ji bae ha da) — to rule <br></br>
국가 (guk ga) — kingdom/country <br></br>
이성계 — Lee Sung Gae, the first king of Joseon (also known as 태조 Taejo) (pictured below) <br></br>
<img className="epPic" src="https://upload.wikimedia.org/wikipedia/commons/6/6a/King_Taejo_Yi_02.jpg"></img><br></br>
<br></br>

<br></br>
{/*WIFES*/}
첫 번째 (chut bun jjae) — first <br></br>
왕 (wang) — king  <br></br>
왕비 (wang bi) — queen <br></br>
부인 (boo in) — wife <br></br>
후궁 (hoo goong) — concubines <br></br>
맏아들 (mat ah deul) — oldest son <br></br>
자리 (ja ri) — position <br></br>
물려받다 (mul ryeo bat da) — to inherit <br></br>
의무를 진다 (euh muh reul jin da) — to bear the responsibility of <br></br>

<br></br>
{/*RECORDS*/}
조선왕조실록 (Jo Seon Wang Jo Sil Rok) — Veritable Records of the Joseon Dynasty, containing daily records of national affairs and the government (pictured below)<br></br>
<img className="epPic" src="https://i.ytimg.com/vi/TP3K7HwH3U4/maxresdefault.jpg"></img><br></br>
<br></br>
사관 (sah gwan) — professional historiographers that wrote the records <br></br>
사초 (sa cho) — daily records in the Veritable Records of the Joseon Dynasty  <br></br>
어느날 (uh neu nal) — one day <br></br>
떨어지다 (ddeul uh ji da) — fall off <br></br>
경복궁 (gyeong bok goong) — the palace the king resided and worked in (pictured below)<br></br>
<img className="epPic" src="https://www.corejeju.com/wp-content/uploads/2017/01/Gyeongbokgung-Palace.jpg"></img><br></br>
<br></br>
서울 (suh oul) — the capital of Korea <br></br>

<br></br>
{/*CLOTHES*/}
익선관 (eek sun gwan) — the head gear the king wore, which almost looks like a baseball cap worn backwards with the front facing up (pictured below) <br></br>
<img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/4/46/Horsehair_Hat_Worn_by_King_Gojong_%28Presumed%29.jpg"></img><br></br>
<br></br>
특별한 날 (teuk byeol han nal) — special days <br></br>
면류관 (myeon ryu gwan) — a special crown like a western graduation cap with beads hanging on the front and back <br></br>
옷 (ot) — clothes <br></br>
빨간 (ppal gan) — red <br></br>
곤룡포 (gon ryong po) — red robe (pictured below)<br></br>
<img className="epPic" src="https://folkency.nfm.go.kr/upload/img/20180823/20180823175921_t_.jpg"></img><br></br>
<br></br>

<br></br>
{/*TOMBS*/}
무덤 (moo dum) — tomb <br></br>
특이한 점 (teuk eeh han jum) — the interesting thing/point <br></br>
<br></br> Pictured below: royal tombs (왕릉) <br></br>
<img className="epPic" src="https://dimg.donga.com/wps/NEWS/IMAGE/2009/06/29/7135434.1.jpg"></img><br></br>
<br></br>
언덕 (un duk) — hills <br></br>
3공간 (sae gong gan) — 3 spaces <br></br>
첫 번째 (chut bun jjae) — first <br></br>
진입 (jin ip) — enter <br></br>
공간 (gong gan) — space <br></br>
두 번째 (doo bun jjae) — second <br></br>
산 자 (san ja) — one who is alive <br></br>
죽은 자 (juk eun ja) — one who is dead <br></br>
만남 (man nam) — meeting <br></br>
만남의 공간 (man nam ae gong gan) — the place of meeting <br></br>
세 번째 (sae bun jjae) — third <br></br>

왕릉 (wang reung) — royal tomb <br></br>
보존 (bo jon) — preservation <br></br>
상태 (sang tae) — state <br></br>
양호하다 (yang ho ha da) — to be good <br></br>

<br></br>
{/*CONCLUSION*/}
만들다 (man deul da) — to make <br></br>
썼던 (sseut dun) — used (comes from 썻다, which means to use) <br></br>
도구 (do goo) — tool <br></br>
인력 (in ryeok) — human labor <br></br>
기록 (gi rok) — record <br></br>
보존되다 (bo jon dwae da) — to be preserved <br></br>
장례 (jang rae) — funeral <br></br>
문화 (mun hwa) — culture <br></br>
규정 (gyu jeong) — rules <br></br>
과정 (gwa jeong) — process <br></br>




                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;